export default [
	{
		modulo: 20,
		privilegio: 165,
		routerName: 'procedimento-operacional',
		routerPath: '/procedimento-operacional',
		componentName: 'ProcedimentoOperacional',
		componentPath: 'modules/layout/documentacao/procedimento-operacional/main'
	},
	{
		modulo: 20,
		privilegio: 190,
		routerName: 'normas-legislacao',
		routerPath: '/normas-legislacao',
		componentName: 'NormasLegislacao',
		componentPath: 'modules/layout/documentacao/normas-legislacao/main'
	},
	{
		modulo: 20,
		privilegio: 191,
		routerName: 'planilhas-projetos',
		routerPath: '/planilhas-projetos',
		componentName: 'PlanilhasProjetos',
		componentPath: 'modules/layout/documentacao/planilhas-projetos/main'
	},
	{
		modulo: 20,
		privilegio: 237,
		routerName: 'tipo-documento',
		routerPath: '/tipo-documento',
		componentName: 'TipoDocumento',
		componentPath: 'modules/layout/documentacao/tipo-documento/main'
	},
	{
		modulo: 20,
		routerName: 'tipo-documento-cadastro',
		routerPath: '/tipo-documento/cadastro',
		componentName: 'TipoDocumentoCadastro',
		componentPath: 'modules/layout/documentacao/tipo-documento/form'
	},
	{
		modulo: 20,
		props: true,
		routerName: 'tipo-documento-editar',
		routerPath: '/tipo-documento/editar/:id',
		componentName: 'TipoDocumentoEditar',
		componentPath: 'modules/layout/documentacao/tipo-documento/form'
	},
	{
		modulo: 20,
		privilegio: 273,
		routerName: 'indice-documento',
		routerPath: '/indice-documento',
		componentName: 'IndiceDocumento',
		componentPath: 'modules/layout/documentacao/indice-documento/main'
	},
	{
		modulo: 20,
		privilegio: 273,
		routerName: 'indice-documento-cadastro',
		routerPath: '/indice-documento/cadastro/',
		componentName: 'IndiceDocumentoCadastro',
		componentPath: 'modules/layout/documentacao/indice-documento/form'
	},
	{
		modulo: 20,
		privilegio: 273,
		props: true,
		routerName: 'indice-documento-editar',
		routerPath: '/indice-documento/editar/:id',
		componentName: 'IndiceDocumentoEditar',
		componentPath: 'modules/layout/documentacao/indice-documento/form'
	},
	{
		modulo: 20,
		privilegio: 273,
		props: true,
		routerName: 'indice-documento-visualizar',
		routerPath: '/indice-documento/visualizar/:id',
		componentName: 'IndiceDocumentoVisulizar',
		componentPath: 'modules/layout/documentacao/indice-documento/print'
	}
]
